import script from "./Hero.vue?vue&type=script&lang=tsx"
export * from "./Hero.vue?vue&type=script&lang=tsx"

import "./Hero.vue?vue&type=style&index=0&id=38c762b4&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c762b4"]])

export default __exports__